/* ================================================================
   fos-waitlist.js
   Homepage landing override for formsofself.com.

   Loaded from snippets/fos-nav-rewrites.liquid via:
     <script>window.FOS_ASSETS = { landingBg: '{{ '...' | asset_url }}' };</script>
     <script src="{{ 'fos-waitlist.js' | asset_url }}" defer></script>

   Design: rooftop photo (Sony-3301) as the full-viewport background.
   Studio-flash intro sequence mirroring the visual novel opener:
     0.0s  black
     0.4s  fos wordmark blooms in (purple, over-exposed then settled)
     ~2.4s photo + veil fade in, ornament + subtitle + form cascade
     3.4s  corner mark and copyright arrive last

   Typography follows the woven-label / clothing-tag treatment:
     purple italic fos wordmark, hairline+dot+hairline ornament,
     wide-tracked forms of self subtitle below.
   ================================================================ */
(function () {
  'use strict';

  // Homepage only.
  var path = (window.location.pathname || '').replace(/\/+$/, '');
  if (path !== '' && path !== '/en' && path !== '/fr') return;

  var LANDING_BG = (window.FOS_ASSETS && window.FOS_ASSETS.landingBg) || '';
  var SUCCESS = /[?&]customer_posted=true/.test(window.location.search);

  function inject() {
    if (document.getElementById('fos-wl-root')) return;
    document.body.classList.add('fos-wl-active');

    // Stylesheet ------------------------------------------------------
    var css = [
      /* Hide native homepage sections AND the legacy fos-waitlist-override
         markup in fos-nav-rewrites.liquid so only this JS-injected version
         renders. */
      'body.fos-wl-active > header,',
      'body.fos-wl-active > nav,',
      'body.fos-wl-active > footer,',
      'body.fos-wl-active > main,',
      'body.fos-wl-active > .shopify-section,',
      'body.fos-wl-active > div.shopify-section,',
      'body.fos-wl-active [id^="shopify-section-"],',
      'body.fos-wl-active .fos-waitlist-override',
      '{ display: none !important; }',
      'body.fos-wl-active #fos-wl-root { display: block !important; }',
      'body.fos-wl-active { margin:0 !important; padding:0 !important; background:#000 !important; overflow:hidden !important; }',

      /* Root — full viewport, starts pure black. Photo fades in later. */
      '#fos-wl-root { position:fixed; inset:0; z-index:99999; width:100vw; height:100vh; background:#000; color:#ebd3a2; font-family:"Cormorant Garamond","EB Garamond","Times New Roman",serif; overflow:hidden; }',

      /* Background photo — Sony-3301 rooftop. Fades in after the intro
         wordmark has bloomed. */
      '#fos-wl-root .fos-wl-photo { position:absolute; inset:0; background-image:url("' + LANDING_BG + '"); background-size:cover; background-position:center; background-repeat:no-repeat; opacity:0; animation:fos-wl-photo-reveal 1.8s cubic-bezier(0.2, 0.65, 0.3, 1) 2.2s forwards; }',
      '@keyframes fos-wl-photo-reveal { from { opacity:0; } to { opacity:1; } }',

      /* Subtle radial darkening behind the copy area so text stays legible
         over the photo. No full-gradient wash — the photo carries the mood. */
      '#fos-wl-root .fos-wl-veil { position:absolute; inset:0; background:radial-gradient(ellipse at center, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.2) 55%, rgba(0,0,0,0) 100%); opacity:0; animation:fos-wl-veil-fade 1.8s ease 2.2s forwards; pointer-events:none; }',
      '@keyframes fos-wl-veil-fade { from { opacity:0; } to { opacity:1; } }',

      /* Center stack — wordmark + ornament + subtitle + form. */
      '#fos-wl-root .fos-wl-center { position:absolute; inset:0; z-index:2; display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; padding:40px 24px; }',

      /* Wordmark — purple italic Cormorant. Studio-flash entry: starts
         over-exposed white with heavy bloom, collapses into the settled
         FOS purple. Mirrors the VN intro exactly. */
      '#fos-wl-root .fos-wl-wordmark { font-family:"Cormorant Garamond",serif; font-style:italic; font-weight:500; color:#4c1d95; font-size:clamp(96px, 17vw, 220px); line-height:1; letter-spacing:0.06em; text-transform:lowercase; margin:0; opacity:0; transform:scale(0.86); animation:fos-wl-wordmark-flash 2.4s cubic-bezier(0.15, 0.7, 0.3, 1) 0.4s forwards; will-change:opacity, transform, text-shadow, filter; }',
      '@keyframes fos-wl-wordmark-flash {',
      '  0%   { opacity:0; transform:scale(0.86); filter:blur(14px) brightness(3); text-shadow:0 0 130px rgba(255,255,255,1), 0 0 220px rgba(203,182,230,0.85); }',
      '  8%   { opacity:1; transform:scale(1.06); filter:blur(0) brightness(3.2); text-shadow:0 0 150px rgba(255,255,255,1), 0 0 240px rgba(203,182,230,1); }',
      '  22%  { opacity:1; transform:scale(1);    filter:blur(0) brightness(1.8); text-shadow:0 0 95px rgba(203,182,230,0.85); }',
      '  55%  { opacity:1; transform:scale(1);    filter:blur(0) brightness(1.15); text-shadow:0 0 60px rgba(76,29,149,0.6); }',
      '  100% { opacity:1; transform:scale(1);    filter:blur(0) brightness(1);    text-shadow:0 0 50px rgba(76,29,149,0.5); }',
      '}',

      /* Ornament — hairline + dot + hairline, echoing the clothing tag. */
      '#fos-wl-root .fos-wl-ornament { display:flex; align-items:center; justify-content:center; gap:14px; margin:16px 0 10px; opacity:0; animation:fos-wl-fade 1.4s ease 2.3s forwards; }',
      '#fos-wl-root .fos-wl-ornament .line { display:block; width:78px; height:1px; background:#ebd3a2; opacity:0.8; }',
      '#fos-wl-root .fos-wl-ornament .dot { display:block; width:5px; height:5px; border-radius:50%; background:#cbb6e6; opacity:0.95; box-shadow:0 0 10px rgba(203,182,230,0.6); }',

      /* Forms of self subtitle — cream, wide-tracked, italic. */
      '#fos-wl-root .fos-wl-sub { font-family:"Cormorant Garamond",serif; font-style:italic; font-weight:500; color:#ebd3a2; font-size:clamp(18px, 2.4vw, 30px); letter-spacing:0.72em; padding-left:0.72em; text-transform:lowercase; margin:0 0 46px; opacity:0; animation:fos-wl-fade 1.6s ease 2.5s forwards; text-shadow:0 2px 20px rgba(0,0,0,0.75); }',

      /* Tagline. */
      '#fos-wl-root .fos-wl-tag { font-family:"Cormorant Garamond",serif; font-style:italic; color:#dcd0b8; font-size:clamp(14px, 1.75vw, 18px); letter-spacing:0.1em; text-transform:lowercase; margin:0 auto 32px; max-width:420px; line-height:1.55; opacity:0; animation:fos-wl-fade 1.6s ease 2.9s forwards; text-shadow:0 2px 12px rgba(0,0,0,0.75); }',

      /* Form. */
      '#fos-wl-root form { width:100%; max-width:360px; display:flex; flex-direction:column; gap:10px; margin:0 auto; opacity:0; animation:fos-wl-fade 1.6s ease 3.1s forwards; }',
      '#fos-wl-root input[type="email"] { width:100%; padding:15px 18px; background:rgba(0,0,0,0.55); border:1px solid rgba(203,182,230,0.42); color:#ebd3a2; font-family:"Cormorant Garamond",serif; font-size:15px; letter-spacing:0.05em; text-align:center; outline:none; -webkit-backdrop-filter:blur(4px); backdrop-filter:blur(4px); box-sizing:border-box; }',
      '#fos-wl-root input[type="email"]::placeholder { color:rgba(235,211,162,0.55); font-style:italic; text-align:center; }',
      '#fos-wl-root input[type="email"]:focus { border-color:#a855f7; }',
      '#fos-wl-root button { width:100%; padding:15px 24px; background:#c8102e; color:#0a0208; border:0; box-shadow:inset 0 0 0 3px #a855f7; font-family:"Cormorant Garamond",serif; font-weight:600; font-size:14px; letter-spacing:0.22em; text-transform:lowercase; cursor:pointer; transition:background .25s ease, color .25s ease; }',
      '#fos-wl-root button:hover { background:#ebd3a2; color:#1a0533; }',
      '#fos-wl-root .fos-wl-success { margin-top:10px; font-size:12px; font-style:italic; text-align:center; letter-spacing:0.1em; color:#96d1aa; }',

      /* Shared cascade fade used by ornament, subtitle, tagline, form,
         corner mark, copyright. */
      '@keyframes fos-wl-fade { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }',

      /* Corner mark — bottom-left, small purple fos, no filled box. */
      '#fos-wl-root .fos-wl-tag-mark { position:fixed; left:28px; bottom:28px; z-index:3; padding:8px 16px; background:rgba(10,2,8,0.55); border:0.5px solid rgba(76,29,149,0.55); border-radius:2px; display:flex; align-items:center; justify-content:center; opacity:0; animation:fos-wl-fade 1.4s ease 3.4s forwards; -webkit-backdrop-filter:blur(4px); backdrop-filter:blur(4px); }',
      '#fos-wl-root .fos-wl-tag-mark .tm-fos { font-family:"Cormorant Garamond",serif; font-style:italic; font-weight:500; color:#4c1d95; font-size:17px; line-height:1; letter-spacing:0.02em; text-shadow:0 0 14px rgba(76,29,149,0.55); }',

      /* Copyright — bottom-right. */
      '#fos-wl-root .fos-wl-copy { position:fixed; right:30px; bottom:30px; z-index:3; font-family:"Cormorant Garamond",serif; font-size:10px; letter-spacing:0.15em; color:#dcd0b8; text-align:right; line-height:1.6; opacity:0; animation:fos-wl-fade 1.4s ease 3.4s forwards; text-shadow:0 1px 8px rgba(0,0,0,0.85); }',
      '#fos-wl-root .fos-wl-copy .cline { display:block; }',
      '#fos-wl-root .fos-wl-copy .cline em { font-style:italic; color:#cbb6e6; }',

      '@media (max-width: 640px) {',
      '  #fos-wl-root .fos-wl-tag-mark, #fos-wl-root .fos-wl-copy { position:absolute; }',
      '}'
    ].join(' ');

    var style = document.createElement('style');
    style.id = 'fos-wl-style';
    style.textContent = css;
    document.head.appendChild(style);

    // DOM -------------------------------------------------------------
    var root = document.createElement('div');
    root.id = 'fos-wl-root';

    var successMark = SUCCESS
      ? '<p class="fos-wl-success">you are on the list.</p>'
      : '';

    root.innerHTML =
      '<div class="fos-wl-photo"></div>' +
      '<div class="fos-wl-veil"></div>' +

      '<div class="fos-wl-center">' +
        '<span class="fos-wl-wordmark">fos</span>' +
        '<div class="fos-wl-ornament">' +
          '<span class="line"></span>' +
          '<span class="dot"></span>' +
          '<span class="line"></span>' +
        '</div>' +
        '<span class="fos-wl-sub">forms of self</span>' +
        '<span class="fos-wl-tag">the descent continues.</span>' +
        '<form method="post" action="/contact#contact_form" accept-charset="UTF-8">' +
          '<input type="hidden" name="form_type" value="customer">' +
          '<input type="hidden" name="utf8" value="&#10003;">' +
          '<input type="hidden" name="contact[tags]" value="fos-deliverance-p2-waitlist,newsletter">' +
          '<input type="hidden" name="contact[accepts_marketing]" value="1">' +
          '<input type="email" name="contact[email]" placeholder="your email" required autocomplete="email">' +
          '<button type="submit">enter the descent</button>' +
          successMark +
        '</form>' +
      '</div>' +

      '<div class="fos-wl-tag-mark">' +
        '<span class="tm-fos">fos</span>' +
      '</div>' +

      '<div class="fos-wl-copy">' +
        '<span class="cline">© fos co., 2026 &middot; <em>made in hong kong</em></span>' +
        '<span class="cline">registered in canada</span>' +
      '</div>';

    document.body.appendChild(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  window.addEventListener('load', function () { setTimeout(inject, 200); });
})();
